import './styles.scss'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import BlockTwoCol from '@/components/BlockTwoCol'
import CustomButton from '@/components/CustomButton'
import { linkGenerator } from '@/libs/utils/language'
import accessoriesDetergentsImage from '@/assets/img/acc-detergents-image.webp'

const ContentWrapper = (materialNumber: string, options = {}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const description = t(
    'productDetails.accessoriesDetergents.description',
  ).split('\n')

  const descriptionLines = description
    .map((v) => v.trim())
    .map((text, index) => ({ index, text }))

  return (
    <div className="accessories-detergents__content">
      <h2 className="block-two-col__header">
        {t('productDetails.accessoriesDetergents.title')}
      </h2>
      <div className="block-two-col__content">
        {descriptionLines.map((line) => <p key={line.index}>{line.text}</p>)}
      </div>
      <div className="block-two-col__footer">
        <div className="accessories-detergents__btn-wrapper">
          {options.showAccessoriesButton && (
            <CustomButton
              block
              onClick={() => {
                navigate(
                  linkGenerator(`/product/${materialNumber}/accessories`),
                )
              }}
            >
              {t('productDetails.accessoriesDetergents.button.showAccessories')}
            </CustomButton>
          )}
          {options.showDetergentsButton && (
            <CustomButton
              block
              onClick={() => {
                navigate(linkGenerator(`/product/${materialNumber}/detergents`))
              }}
            >
              {t('productDetails.accessoriesDetergents.button.showDetergents')}
            </CustomButton>
          )}
        </div>
      </div>
    </div>
  )
}

function ImagesWrapper() {
  return (
    <div className="accessories-detergents__image">
      <img
        alt="accessories-detergents"
        height="auto"
        loading="lazy"
        src={accessoriesDetergentsImage}
        width="100%"
      />
    </div>
  )
}

interface AccessoriesDetergentsProps {
  materialNumber?: string
  options?: {
    showAccessoriesButton?: boolean
    showDetergentsButton?: boolean
  }
}

function AccessoriesDetergents(props: AccessoriesDetergentsProps) {
  const { materialNumber = '', options } = props
  return (
    <BlockTwoCol
      className="accessories-detergents"
      left={ContentWrapper(materialNumber, options)}
      right={ImagesWrapper()}
    />
  )
}

export default AccessoriesDetergents
